// Payment constants - must match backend values
export const PAYMENT_CONSTANTS = {
  PRICE_CENTS: 2999, // $29.99 in cents
  PRICE_DOLLARS: 29.99,
  PRODUCT_NAME: "VocreaAI - Full Therapist Access",
  PRODUCT_DESCRIPTION: "One-time payment for unlimited access to all therapist profiles",
};
